module.exports = __webpack_public_path__ + "assets/img/2.91b3d2a1.png";